import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { Table } from "react-bootstrap";
import { TabPanel, TabView } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Card, Badge } from "react-bootstrap";
import parse from "html-react-parser";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledCurrencyField,
} from "../../../../../partials/content/Forms";
import Illustration from "../../../../../partials/content/Illustration";
import { formatDate } from "../../../../../utils/utils";
import { Typography } from "@material-ui/core";
import { Timeline } from "primereact/timeline";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import { getSalesOrder } from "../../../../../services/sales/salesOrderService";
import { Editor } from "primereact/editor";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
const SoBasicInfo = ({
  salesOrderID = 0,
  salesOrderImp = {
    ID: 0,
    salesOrderCode: "",
    customer: { customerName: "" },
    currency: { currencyCode: "" },
    salesOrderItem: [],
    salesOrderAddCost: [],
    soBillingAddress: { address: "" },
    soDeliveryAddress: { address: "" },
    salesName: "",
    customerPoNo: "",
    approvalStatusDesc: "",
    note: "",
    toc: "",
  },
  approvalProcessImp = [],
  approvalStepsImp = [],
  approvalActiveStepImp = 0,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [salesOrder, setSalesOrder] = useState(salesOrderImp);
  const [approvalProcess, setApprovalProcess] = useState(approvalProcessImp);
  const [approvalSteps, setApprovalSteps] = useState(approvalStepsImp);
  const [approvalActiveStep, setApprovalActiveStep] = useState(
    approvalActiveStepImp
  );
  useEffect(() => {
    if (salesOrderID > 0) {
      getSalesOrderData(salesOrderID);
    }
  }, [salesOrderID]);

  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Sales Order Main" rightIcon="fas fa-th-large">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Sales Order Header</strong>
                      </span>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          salesOrder.invoiceStatus === 1
                            ? "danger"
                            : salesOrder.invoiceStatus === 2
                            ? "warning"
                            : salesOrder.invoiceStatus === 3
                            ? "success"
                            : null
                        }
                      >
                        {salesOrder.invoiceStatus !== 0
                          ? "Invoice " + salesOrder.invoiceStatusDesc
                          : null}
                      </Badge>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          salesOrder.giStatus === 1
                            ? "danger"
                            : salesOrder.giStatus === 2
                            ? "warning"
                            : salesOrder.giStatus === 3
                            ? "success"
                            : null
                        }
                      >
                        {salesOrder.giStatus !== 0
                          ? "Goods " + salesOrder.giStatusDesc
                          : null}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Sales Order ID"
                            value={salesOrder.salesOrderCode}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Customer Name"
                            value={salesOrder.customer.customerName}
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Currency"
                                value={salesOrder.currency.currencyCode}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Exchange Rate To Base Currency"
                                value={salesOrder.exchangeRate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Order Date"
                                value={formatDate(salesOrder.orderDate)}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Expected Delivery Date"
                                value={formatDate(salesOrder.expDeliveryDate)}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Sales Agent"
                                value={salesOrder.salesName}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Customer PO Number"
                                value={salesOrder.customerPoNo}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Approval Status"
                            value={salesOrder.approvalStatusDesc}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Sales Order Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="card">
                                <Table
                                  striped
                                  borderless
                                  size="sm"
                                  responsive="xl"
                                >
                                  {salesOrder.salesOrderItem &&
                                  salesOrder.salesOrderItem.length > 0 ? (
                                    <thead>
                                      <tr>
                                        <th style={{ width: "30%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Item Name
                                          </Typography>
                                        </th>
                                        <th style={{ width: "5%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Quantity
                                          </Typography>
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Unit
                                          </Typography>
                                        </th>
                                        <th style={{ width: "20%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Unit Price
                                          </Typography>
                                        </th>
                                        <th style={{ width: "15%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Item Discount
                                          </Typography>
                                        </th>
                                        <th style={{ width: "20%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Total Price
                                          </Typography>
                                        </th>
                                      </tr>
                                    </thead>
                                  ) : null}
                                  <tbody>
                                    {salesOrder.salesOrderItem &&
                                    salesOrder.salesOrderItem.length > 0 ? (
                                      salesOrder.salesOrderItem.map(
                                        (item, index) => (
                                          <tr
                                            key={index}
                                            className="border-top"
                                          >
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.itemType > 0 ? (
                                                  <span>
                                                    <BootstrapTooltip
                                                      title={item.itemTypeName}
                                                    >
                                                      <span className="mr-2">
                                                        <i
                                                          className={
                                                            item.itemType === 1
                                                              ? "fas fa-boxes text-success"
                                                              : item.itemType ===
                                                                2
                                                              ? "fas fa-tools text-primary"
                                                              : item.itemType ===
                                                                3
                                                              ? "fas fa-building text-info"
                                                              : item.itemType ===
                                                                4
                                                              ? "fas fa-boxes text-warning"
                                                              : item.itemType ===
                                                                5
                                                              ? "fas fa-boxes text-danger"
                                                              : null
                                                          }
                                                        ></i>
                                                      </span>
                                                    </BootstrapTooltip>
                                                    <span>
                                                      {item.itemCode}{" "}
                                                      {item.itemName}
                                                    </span>
                                                  </span>
                                                ) : (
                                                  <React.Fragment>
                                                    {item.itemCode}{" "}
                                                    {item.itemName}
                                                  </React.Fragment>
                                                )}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.qty}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.uomName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.unitPrice}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {salesOrder.currencyCode}{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.discountAmount}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {salesOrder.currencyCode}{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.totalPrice}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {salesOrder.currencyCode}{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center py-3"
                                          colSpan="6"
                                        >
                                          <Illustration
                                            imageSource="INVIFO Sales.png"
                                            guidance="You don't have any Sales items yet"
                                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                            size="sm"
                                          ></Illustration>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                              <Card>
                                <Card.Body>
                                  <div className="card">
                                    <Table
                                      striped
                                      borderless
                                      size="sm"
                                      responsive="xl"
                                    >
                                      {salesOrder.salesOrderAddCost &&
                                      salesOrder.salesOrderAddCost.length >
                                        0 ? (
                                        <thead>
                                          <tr>
                                            <th style={{ width: "60%" }}>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Cost Name
                                              </Typography>
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Cost Price
                                              </Typography>
                                            </th>
                                          </tr>
                                        </thead>
                                      ) : null}
                                      <tbody>
                                        {salesOrder.salesOrderAddCost &&
                                        salesOrder.salesOrderAddCost.length >
                                          0 ? (
                                          salesOrder.salesOrderAddCost.map(
                                            (item, index) => {
                                              return (
                                                <tr
                                                  key={index}
                                                  className="border-top"
                                                >
                                                  <td>
                                                    <Typography className="mx-1 my-1">
                                                      {item.itemName}
                                                    </Typography>
                                                  </td>
                                                  <td>
                                                    <Typography
                                                      component="div"
                                                      className="mx-1 my-1"
                                                    >
                                                      <NumberFormat
                                                        value={item.costPrice}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                        renderText={(value) => (
                                                          <div className="float-right">
                                                            {
                                                              salesOrder.currencyCode
                                                            }{" "}
                                                            {value}
                                                          </div>
                                                        )}
                                                      />
                                                    </Typography>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              className="text-center"
                                              colSpan="2"
                                            >
                                              <Illustration
                                                guidance="No additional cost"
                                                guidanceLeftIcon="fas fa-info-circle kt-font-success"
                                              ></Illustration>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography className="kt-font-bolder">
                                            Additional Cost Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={salesOrder.addCostTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {salesOrder.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <Card>
                                <Card.Body className="pb-0">
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr className="border-bottom">
                                        <td style={{ width: "50%" }}>
                                          <Typography className="mb-3 kt-font-bolder">
                                            Sub Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="mb-3 kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={salesOrder.subTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {salesOrder.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesOrder.discountPercent}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div>
                                                  Discount{" ("}
                                                  {value}
                                                  {"%)"}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesOrder.discountAmount}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  - {salesOrder.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesOrder.taxPercent}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div>
                                                  Tax{" ("}
                                                  {value}
                                                  {"%)"}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesOrder.taxAmount}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {salesOrder.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <Typography className="my-3">
                                            Additional Cost
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={salesOrder.addCostTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {salesOrder.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            className="kt-font-bolder"
                                          >
                                            Grand Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={salesOrder.grandTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {salesOrder.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Addresses" rightIcon="fas fa-map-marked-alt">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-map-marked-alt"></i>
                      <span>
                        <strong>Billing Address</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Address"
                            value={salesOrder.soBillingAddress.address}
                          />
                          <CustomOutlinedDisabledTextField
                            label="City"
                            value={salesOrder.soBillingAddress.city}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Province / State"
                            value={salesOrder.soBillingAddress.province}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Phone Number"
                            value={salesOrder.soBillingAddress.addressPhone}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Email"
                            value={salesOrder.soBillingAddress.addressEmail}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Postal Code"
                            value={salesOrder.soBillingAddress.postalCode}
                          />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <CustomOutlinedDisabledTextField
                            label="Country"
                            value={salesOrder.soBillingAddress.countryName}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-map-marked-alt"></i>
                      <span>
                        <strong>Shipping Address</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Address"
                            value={salesOrder.soDeliveryAddress.address}
                          />
                          <CustomOutlinedDisabledTextField
                            label="City"
                            value={salesOrder.soDeliveryAddress.city}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Province / State"
                            value={salesOrder.soDeliveryAddress.province}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Phone Number"
                            value={salesOrder.soDeliveryAddress.addressPhone}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Email"
                            value={salesOrder.soDeliveryAddress.addressEmail}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Postal Code"
                            value={salesOrder.soDeliveryAddress.postalCode}
                          />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <CustomOutlinedDisabledTextField
                            label="Country"
                            value={salesOrder.soDeliveryAddress.countryName}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={salesOrder.note}
                        placeholder="Type your notes here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Terms & Conditions</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={salesOrder.toc}
                        placeholder="Type your terms & conditions here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            {approvalProcess.length ? (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
              >
                {approvalSteps.length ? (
                  <Stepper activeStep={approvalActiveStep} alternativeLabel>
                    <Step>
                      <StepLabel
                        optional={
                          <Typography align="center" variant="body2">
                            INITIATED
                          </Typography>
                        }
                      >
                        Document Approval
                      </StepLabel>
                    </Step>
                    {approvalSteps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (label.level < salesOrder.approvalProcess.level)
                        labelProps.optional = (
                          <Typography
                            align="center"
                            variant="body2"
                            className="text-success"
                          >
                            APPROVED
                          </Typography>
                        );
                      if (
                        label.approvalID ===
                          salesOrder.approvalProcess.approvalID &&
                        label.level === salesOrder.approvalProcess.level
                      ) {
                        if (salesOrder.approvalProcess.statusID === 1) {
                          labelProps.error = false;
                          labelProps.optional = (
                            <Typography align="center" variant="body2">
                              IN REVIEW
                            </Typography>
                          );
                        } else if (salesOrder.approvalProcess.statusID === 2) {
                          labelProps.error = false;
                          stepProps.completed = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-success"
                            >
                              APPROVED
                            </Typography>
                          );
                        } else if (salesOrder.approvalProcess.statusID === 3) {
                          labelProps.error = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-danger"
                            >
                              REJECTED
                            </Typography>
                          );
                        }
                      }
                      return (
                        <Step key={index} {...stepProps}>
                          <StepLabel {...labelProps}>
                            {label.userGroup.groupName}
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                ) : null}
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-history"></i>
                        <span>
                          <strong>Approval Flow History</strong>
                        </span>
                      </Card.Header>
                      <Card.Body>
                        <Timeline
                          value={approvalProcess}
                          opposite={(item) => {
                            return (
                              <div>
                                {item.statusDesc}
                                {item.statusID === 2 || item.statusID === 3 ? (
                                  <React.Fragment>
                                    <br />
                                    <strong>Note :</strong>
                                    <br />
                                    {parse(item.note)}
                                  </React.Fragment>
                                ) : null}
                              </div>
                            );
                          }}
                          content={(item) => {
                            return (
                              <small className="text-muted">
                                {formatDate(item.actionDate, true)}
                              </small>
                            );
                          }}
                          marker={(item) => {
                            if (item.statusID === 0) {
                              return (
                                <span className="custom-timeline-marker bg-info">
                                  <i className="fas fa-play-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 1) {
                              return (
                                <span className="custom-timeline-marker bg-warning">
                                  <i className="fas fa-clock"></i>
                                </span>
                              );
                            } else if (item.statusID === 2) {
                              return (
                                <span className="custom-timeline-marker bg-success">
                                  <i className="fas fa-check-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 3) {
                              return (
                                <span className="custom-timeline-marker bg-danger">
                                  <i className="fas fa-times-circle"></i>
                                </span>
                              );
                            } else {
                              return (
                                <span className="custom-timeline-marker bg-dark">
                                  <i className="fas fa-question-circle"></i>
                                </span>
                              );
                            }
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
                disabled
              ></TabPanel>
            )}
          </TabView>
        </div>
      </div>
    </React.Fragment>
  );

  async function getSalesOrderData(salesOrderID = 0) {
    const response = await getSalesOrder(salesOrderID, "true");
    const { data } = response.data;
    setSalesOrder(data.salesOrder);
    setApprovalProcess(data.approvalProcess);
    setApprovalSteps(data.salesOrder.approvalProcess.approval.approvalValue);
    setApprovalActiveStep(data.salesOrder.approvalProcess.level);
  }
};

export default SoBasicInfo;
